import React, { FC, useState } from 'react';
import Filter from './Filter';
import Button from 'ui/Button';
import Tooltip from 'ui/Tooltip';
import Search from 'ui/Search';

interface IControlPanel {
  isAdmin: boolean;
  setSearchOptions: (state: any) => void;
  setFilterOptions: (state: any) => void;
  isSearchActive: boolean;
  setIsSearchActive: (state: boolean) => void;
  setIsFilterActive: (state: boolean) => void;
  setIsFormVisible: (state: boolean) => void;
}

const ControlPanel: FC<IControlPanel> = ({
  isAdmin,
  setSearchOptions,
  setFilterOptions,
  setIsFilterActive,
  isSearchActive,
  setIsSearchActive,
  setIsFormVisible,
}: IControlPanel) => {
  const [isFilterVisible, setIsFilterVisible] = useState<boolean>(false);

  const addCompanyHandler = () => {
    setIsFormVisible(true);
  };

  return (
    <div className="blacklist__control-panel">
      <Search
        name="search"
        placeholder="Search company, email, key person or website"
        stateKeys={['company_name', 'email', 'key_person', 'website']}
        setSearchOptions={setSearchOptions}
        isSearchActive={isSearchActive}
        setIsSearchActive={setIsSearchActive}
        customStyles={{
          maxWidth: '920px',
          width: '100%',
        }}
      />
      <div className={`blacklist__control-panel-action-bar ${isAdmin ? 'isAdmin' : ''}`}>
        {isAdmin && (
          <>
            <Button
              name="button-add"
              action={addCompanyHandler}
              stylePreset="no-bordered"
              customStyle={{
                color: 'white',
              }}
            >
              <img
                className="blacklist__control-panel-button-icon"
                src="/images/pages/Resources/Blacklist/icon_add.svg"
                alt="icon-add"
              />
              <span className="blacklist__control-panel-label">Add</span>
            </Button>
            <Tooltip
              text="DFA blacklist contains records about freight forwarders, that failed in their operations by bad intentions or unprofessional business planning. The company appers in the list only after providing undoubtable proofs about the accident to DFA administration. Unlike ratings, blacklist records are listed only by DFA administration and cannot be populated by other companies."
              customTipStyle={{
                width: '390px',
                padding: '8px 16px',
                lineHeight: '22px',
                color: '#ffffff',
                backgroundColor: '#000c37',
                left: '-120px',
              }}
            >
              <div className="blacklist__control-panel-tooltip-value">
                <img src="/images/pages/Resources/Blacklist/icon_how.svg" alt="how-it-works" />
                <span className="blacklist__control-panel-label">How it works</span>
              </div>
            </Tooltip>
          </>
        )}
        <Button
          name="filter"
          action={() => setIsFilterVisible(true)}
          stylePreset="no-bordered"
          customStyle={{
            color: 'white',
          }}
        >
          <img
            className="blacklist__control-panel-button-icon"
            src="/images/pages/Resources/Blacklist/icon_filter.svg"
            alt="icon-filter"
          />
          <span className="blacklist__control-panel-label">Filter</span>
        </Button>
      </div>

      <Filter
        isFilterVisible={isFilterVisible}
        setIsFilterVisible={setIsFilterVisible}
        setFilterOptions={setFilterOptions}
        setIsFilterActive={setIsFilterActive}
      />
    </div>
  );
};

export default React.memo(ControlPanel);
